import { HttpClient } from '../../../ky/HttpClient';
import { DiagnosesDto } from '../../../dto/DiagnosesDto';

const getAllDiagnoses = async () => {
  return await HttpClient.get('diagnoses/all').json<DiagnosesDto[]>();
};

export { getAllDiagnoses };
